/* eslint-disable complexity, import/order, padding-line-between-statements */
// @ts-nocheck
import { useCallback, useState } from 'react'
import { PaymentDetails } from '@/components/payment/PaymentCard'
import { useInscriptionsApi } from '@/services/api/inscriptionsApi'

type UsePaymentOrderDataResult = {
    paymentDetails: PaymentDetails | null
    loading: boolean
    error: string | null
    fetchPaymentData: (inscriptionId: number) => Promise<void>
}

export const usePaymentOrderData = (): UsePaymentOrderDataResult => {
    const [paymentDetails, setPaymentDetails] = useState<PaymentDetails | null>(
        null
    )
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const inscriptionsApi = useInscriptionsApi()

    const fetchPaymentData = useCallback(
        async (inscriptionId: number) => {
            setLoading(true)
            setError(null)

            try {
                console.log(
                    'Fetching payment data for inscription:',
                    inscriptionId
                )
                const response =
                    await inscriptionsApi.getOrderPaymentWithValidation(
                        inscriptionId
                    )
                console.log('Full API Response:', response)
                console.log('Response structure:', Object.keys(response))

                // Parse SSE format response if needed
                let parsedData = response.data

                // Check if the entire response is a string in SSE format
                let responseString = ''
                if (typeof response === 'string') {
                    responseString = response
                } else if (typeof response.data === 'string') {
                    responseString = response.data
                } else if (response && typeof response === 'object') {
                    // Sometimes the response might be the raw string itself
                    responseString = JSON.stringify(response)
                }

                console.log('Response string to check:', responseString)
                console.log('Response data type:', typeof response.data)
                console.log(
                    'Response data includes event:initial-data:',
                    responseString.includes('event:initial-data')
                )

                // Check if response is in SSE format (string containing "event:initial-data\ndata:{json}")
                if (responseString.includes('event:initial-data')) {
                    console.log('Detected SSE format response, parsing...')
                    const lines = responseString.split('\n')
                    console.log('SSE lines:', lines)
                    const dataLine = lines.find((line) =>
                        line.startsWith('data:')
                    )
                    console.log('Data line found:', dataLine)

                    if (dataLine) {
                        const jsonString = dataLine.substring(5) // Remove "data:" prefix
                        console.log('JSON string to parse:', jsonString)
                        try {
                            const parsedResponse = JSON.parse(jsonString)
                            parsedData = parsedResponse.data // Extract the actual data array
                            console.log(
                                'Successfully parsed SSE data:',
                                parsedData
                            )
                        } catch (parseError) {
                            console.error('Error parsing SSE JSON:', parseError)
                            throw new Error('Error al parsear los datos SSE')
                        }
                    }
                }

                console.log('Response data:', parsedData)
                console.log('Response status:', response.status)

                if (
                    parsedData &&
                    Array.isArray(parsedData) &&
                    parsedData.length > 0
                ) {
                    console.log('Payment orders found:', parsedData.length)
                    // Tomar la primera orden de pago activa
                    const paymentOrder = parsedData[0]
                    console.log('First payment order:', paymentOrder)

                    const transformedPaymentDetails: PaymentDetails = {
                        paymentNumber: paymentOrder.operationNumber,
                        ipAddress: '127.0.0.1', // Default IP as it's not available in OrderPayment
                        enrollment: paymentOrder.invoiceNumber, // This is actually the invoice number, not document number
                        totalAmount: paymentOrder.debitAmount, // Use debitAmount as the total amount
                        discountAmount: paymentOrder.totalDiscounts,
                        finalAmount: paymentOrder.netAmount,
                        date: paymentOrder.createdAt
                            ? new Date(
                                  paymentOrder.createdAt
                              ).toLocaleDateString('es-CO')
                            : '',
                        time: paymentOrder.createdAt
                            ? new Date(
                                  paymentOrder.createdAt
                              ).toLocaleTimeString('es-CO')
                            : '',
                        paymentStatus:
                            paymentOrder.paymentStatusName || 'PENDIENTE',
                        paymentStatusDescription:
                            paymentOrder.paymentStatusDescription ||
                            'Estado de pago no disponible'
                    }
                    // Si los montos vienen en 0, consultamos la orden en SAP
                    if (
                        (transformedPaymentDetails.totalAmount || 0) === 0 ||
                        (transformedPaymentDetails.finalAmount || 0) === 0
                    ) {
                        try {
                            console.log(
                                'Amounts are zero, calling getOrderFromSap for inscription:',
                                inscriptionId
                            )
                            await inscriptionsApi.getOrderFromSap(inscriptionId)
                        } catch (sapError) {
                            console.error(
                                'Error calling get-order-from-sap endpoint:',
                                sapError
                            )
                        }

                        setPaymentDetails({
                            ...transformedPaymentDetails,
                            hasGeneratedOrderFromSap: true
                        })
                    } else {
                        setPaymentDetails(transformedPaymentDetails)
                    }
                } else {
                    console.log(
                        'No payment data found. Response data:',
                        parsedData
                    )
                    console.log('Is data an array?', Array.isArray(parsedData))
                    console.log('Data length:', parsedData?.length)
                    setError(
                        'Aún no se encontraron órdenes de pago para tu inscripción. Por favor valida nuevamente más tarde. Si ya tienes una orden pendiente, puedes continuar con el pago desde el botón.'
                    )
                }
            } catch (err) {
                console.error('Error fetching payment data:', err)
                setError(
                    'Error al cargar los datos de pago: ' +
                        (err instanceof Error
                            ? err.message
                            : 'Error desconocido')
                )
            } finally {
                setLoading(false)
            }
        },
        [inscriptionsApi]
    )

    return {
        paymentDetails,
        loading,
        error,
        fetchPaymentData
    }
}
